import React from "react";
import { Helmet } from "react-helmet-async";
import { useStaticQuery, graphql } from "gatsby";

const SEO = ({ title, description, keywords, article }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
          description
          keywords
          siteUrl
          title
        }
      }
    }
  `);

  const metaTitle = title
    ? `${title} | ${data.site.siteMetadata.title}`
    : data.site.siteMetadata.title;
  const metaDescription = description
    ? description
    : data.site.siteMetadata.description;
  const metaKeywords = keywords
    ? [
        ...data.site.siteMetadata.keywords.split(", "),
        ...keywords.map((keyword) => keyword.name),
      ].join(", ")
    : data.site.siteMetadata.keywords;

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={data.site.siteMetadata.siteUrl} />
      <meta property="og:type" content={article ? "article" : "website"} />
      <meta property="og:profile:first_name" content="Renata" />
      <meta property="og:profile:last_name" content="Bliumaite" />
      <meta
        property="og:profile:username"
        content="renata-bliumaite-e-a-b67aa523a"
      />
      <meta
        property="og:profile:username"
        content="https://www.linkedin.com/in/renata-bliumaite-e-a-b67aa523a/"
      />
      <meta
        property="og:profile:username"
        content="https://www.facebook.com/QTATaxLtd/"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&family=Roboto:wght@300;400;500;700&display=swap"
        rel="stylesheet"
      />
      <link rel="icon" href="../images/logo.png" />
      {/* GOOGLE ANALYTICS */}
      {/* <meta
        name="google-site-verification"
        content="2w4LrqUn9nomZXPd3utfQDWV7BHY09wMINaUmZA40ro"
      /> */}
      <meta
        name="google-site-verification"
        content="erztdky5tAotAdtXRiuKNRq04-ysIj6H6RlNT6LMGHY"
      />
    </Helmet>
  );
};

export default SEO;
